<!--This appears to be the root of the app, containing the global information.
    Skin (color scheme) can be changed when events are emitted, and this is 
    handled here.
-->

<template>
  <div id="app" :class="skin">
    <div class="backgroundcolor">
      <router-view />
    </div>
  </div>
</template>

<script>
import { bus } from "@/main";
export default {
  name: "app",
  components:  {},
  data() {
    return {
      skin: "official-skin",
      homepageid: 0,
    };
  },
  mounted() {},
  created() {
    bus.$on("changeSkin", data => {
      if (data) {
        this.skin = data;
      } else this.skin = "official-skin";
    });
  }
};
</script>



<style lang="scss">
@import url("https://fonts.googleapis.com/css?family=Roboto:300,400,500,700&display=swap");
#app {
  font-family: "Roboto", Helvetica, Arial, sans-serif;
  text-align: center;
}
</style>
